import React from 'react'
import ToggleSwitch from '../../../../../Common/Switch/ToggleSwitch'

const SecurityTab = () => {
    return (
        <div className="space-y-6 pt-4">
            <div className="space-y-3">
                {/* Two-Factor Authentication */}
                <div>
                    <p className="text-dark text-base font-medium m-0">Two-factor Authentication</p>
                </div>
                <div className="flex items-center space-x-4">
                    <ToggleSwitch label="I send or receive digital currency" initial={true} />
                </div>
            </div>

            {/* Change Password */}
            <div className="space-y-3">
                <p className="text-gray-500 text-base font-medium m-0">Change Password</p>

                {/* Current Password */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label
                            htmlFor="current-password"
                            className="text-dark text-sm font-normal block mb-1"
                        >
                            Current Password
                        </label>
                        <input
                            type="password"
                            className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="current-password"
                            placeholder="**** ****"
                            required
                        />
                    </div>
                </div>

                {/* New Password */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label
                            htmlFor="new-password"
                            className="text-dark text-sm font-normal block mb-1"
                        >
                            New Password
                        </label>
                        <input
                            type="password"
                            className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                            id="new-password"
                            placeholder="**** ****"
                            required
                        />
                    </div>
                </div>

                {/* Save Button */}
                <div className="mt-6">
                    <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-10 w-full md:w-auto mt-3">Save</button>
                </div>
            </div>
        </div>

    )
}

export default SecurityTab